<div class="space-between-horizontal-align green-manage-columns-header">
  <span class="font-4 white-12 bold500">{{title}}</span>
  <div class="centered-row-container row-gap-0p5">
    <app-button [type]="'accent-light'" [size]="'small'" (buttonClick)="submit.emit(false)">Cancel</app-button>
    <app-button [type]="'white-green'" [size]="'small'" [disabled]="disabled" (buttonClick)="submit.emit(true)">Apply</app-button>
  </div>
</div>
